export enum AppType {
  android = 'Android',
  apple = 'Apple'
}
